export interface ReleaseAnalytics {
  releaseNoteID: string;
  releaseDate: Date;
  versionNumber: string;
  headerText: string;
  isReleaseNote: boolean;
  totalViews: number;
  uniqueViews: number;
  averageTimeOpened: number;
  averageTimeExpanded: number;
  averageViews: number;
  medianTimeOpened: number;
  medianTimeExpanded: number;
  totalTimeOpened: number;
  totalTimeExpanded: number;
}
